var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-container"},[_vm._l((5),function(i){return _c('div',{key:`skeleton-${i}`,staticClass:"skeleton-item"},[_c('div',{staticClass:"skeleton-label"}),_vm._v(" "),_c('div',{staticClass:"skeleton-value"})])}),_vm._v(" "),_c('div',{staticClass:"skeleton-image"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }